(function () {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var cache = {};
    var timer;
    var preview;

    function hidePreview() {
        clearTimeout(timer);
        if (preview) preview.remove();
        preview = null;
    }

    function showPreview(card, event) {
        var postId = card.dataset.previewPostId;
        if (!postId) return;

        function render(text) {
            if (!text || !card.matches(':hover')) return;
            hidePreview();
            preview = document.createElement('div');
            preview.className = 'gh-card-preview is-body';
            preview.setAttribute('role', 'tooltip');
            preview.textContent = text;
            document.body.appendChild(preview);

            var left = Math.min(event.clientX + 16, window.innerWidth - preview.offsetWidth - 16);
            var top = Math.min(event.clientY + 16, window.innerHeight - preview.offsetHeight - 16);
            preview.style.left = Math.max(16, left) + 'px';
            preview.style.top = Math.max(16, top) + 'px';
        }

        if (cache[postId] !== undefined) return render(cache[postId]);
        fetch('/bookmark/preview/' + encodeURIComponent(postId))
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (data) {
                // 只在成功时缓存，失败（如新文章暂未入库）留待下次悬浮重试
                if (data && data.ok) {
                    cache[postId] = data.preview;
                    render(data.preview);
                }
            })
            .catch(function () {});
    }

    document.addEventListener('mouseenter', function (event) {
        var card = event.target.closest('.gh-card[data-preview-post-id]');
        if (!card) return;
        timer = setTimeout(function () { showPreview(card, event); }, 300);
    }, true);

    document.addEventListener('mouseleave', function (event) {
        if (event.target.closest('.gh-card[data-preview-post-id]')) hidePreview();
    }, true);
    window.addEventListener('scroll', hidePreview, true);
})();
